import { ParsedUrlQuery } from 'querystring';
import { getPropertyType } from './getPropertyType';

export function getPropertySubType(query: ParsedUrlQuery) {
    let propertySubTypes = [] as string[];

    if (query['property_sub_type']) {
        if (Array.isArray(query['property_sub_type'])) {
            propertySubTypes = query['property_sub_type'];
        } else {
            propertySubTypes = [query['property_sub_type']];
        }
    }

    if (propertySubTypes.length === 0) {
        const propertyType = getPropertyType(query);

        if (propertyType === 'houses') {
            return ['detached', 'semi_detached', 'terraced'];
        } else if (propertyType === 'flats') {
            return ['flats'];
        }

        return [];
    }

    return propertySubTypes;
}
